import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  BerechnungsartMonat,
  berechnungsartMonat,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/berechnungsartMonat';
import { Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function BerechnungsartMonatToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  return (
    <div className="flex flex-col gap-4">
      <Heading>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.description',
        )}
      </Heading>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat"
        listeners={{
          onChange() {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <RadioGroup
              value={field.state.value}
              onValueChange={(val) => {
                field.handleChange(val as BerechnungsartMonat);
              }}
              className="flex flex-row">
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.durchschnitt',
                )}
                value={berechnungsartMonat.durchschnitt}
              />
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.exakt',
                )}
                value={berechnungsartMonat.exakt}
              />
            </RadioGroup>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
